import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  constructor(private router: Router, private keycloakSrv: KeycloakService) {}

  async canActivate(): Promise<boolean> {

    const isLoggedIn = await this.keycloakSrv.isLoggedIn();
    if (isLoggedIn) {
      this.router.navigate(['/landing-page']);
      return false; 
    } else {
      this.router.navigate(['/splash']);
      return false; 
    }
  }
}
